














































































































































































import { Vue, Component, Lifecycle, Prop, p, Watch } from "av-ts";
import { ITopic, IOfferingUser, IOffering, IQuestion } from "../../interfaces/models";
import Fetcher from "../../services/Fetcher";
import UserService from "../../services/UserService";

import PageLoader from "../util/PageLoader.vue";
import CollectedBadges from "../util/CollectedBadges.vue";
import OverviewDescription from "../util/OverviewDescription.vue";
import VariableDataVisualiser from "../charts/VariableDataVisualiser.vue";
import QuestionCards from "../questions/QuestionCards.vue";
import TopicService from "../../services/TopicService";

@Component({
    components: {
        VariableDataVisualiser,
        OverviewDescription,
        CollectedBadges,
        QuestionCards,
        PageLoader
    }
})
export default class AdminProfiles extends Vue {
    
    pTopics: ITopic[] = [];
    pEngagementItems: ITopic[] = [];
    pUsers: IOfferingUser[] = [];
    pUsersSplit: string[][];
    offering: IOffering;
    pCurrentUserID: number = -1;
    currentUserRole: string[] = [];
    showQuestions: IQuestion[] = [];
    totalItems: number = 0;
    page: number = 1;
    currentPageSize: number = 10;

    loading: boolean = true;

    @Prop loadUserID = p<string>({
        default: ""
    });

    get currentUserID() {
        return this.pCurrentUserID;
    }

    set currentUserID(newID: number) {
        const offeringUser = this.pUsers.filter(x => x.id == newID)[0];
        if (offeringUser != undefined) {
            this.currentUserRole = offeringUser.roles;
        }
        this.pCurrentUserID = newID;
        this.updateAuthoredQuestions();
    }

    sortOptions: string[] = ["Student Number", "First Name", "Last Name"];
    sortOrder: string = "Student Number";
    sortDesc: Boolean = true;

    get selectedRole() {
        let rolesToString: string = "";
        this.currentUserRole.forEach(x => {
            rolesToString += x;
            if (!(this.currentUserRole.indexOf(x) == this.currentUserRole.length - 1)) {
                rolesToString += ", ";
            }
        });
        return rolesToString ==""? "Student":rolesToString;
    }

    updateQuestions(result: { questions: IQuestion[], totalItems: number }) {
        this.showQuestions = result.questions;
        this.totalItems = result.totalItems;
    }

    updateEngagementItems(newEngagementItems: ITopic[]) {
        this.pEngagementItems = newEngagementItems;
    };

    updateTopics(topics: ITopic[]) {
        this.pTopics = topics;
    };

    updateUsers(newUsers: IOfferingUser[]) {
        console.log("updating");
        this.pUsers = newUsers;
        if (this.loadUserID != "") {
            this.currentUserID = parseInt(this.loadUserID);
        } else {
            this.currentUserID = this.pUsers[0].id!;
        }
        const offeringUser = this.pUsers.filter(x => x.id == this.currentUserID)[0];
        if (offeringUser != undefined) {
            this.currentUserRole = offeringUser.roles;
        }
        this.loading = false;
    }

    sort() {
        this.sortDesc = !this.sortDesc;
    }

    @Lifecycle
    created() {
        Fetcher.get(TopicService.getAllAvailableTopics)
            .on(this.updateTopics);
        Fetcher.get(UserService.getAllAvailableEngagementTypes)
            .on(this.updateEngagementItems);
        UserService.getLoggedInUser()
            .then(offeringUser => this.offering = offeringUser.offering)
            .then(() => {
                if (this.offering != undefined) {
                    UserService.getAllOfferingUsers(this.offering.offeringID)
                        .then((users:IOfferingUser[]) => this.updateUsers(users));
                }
            });
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(TopicService.getAllAvailableTopics)
            .off(this.updateTopics);
        Fetcher.get(UserService.getAllAvailableEngagementTypes)
            .off(this.updateEngagementItems);
    }

    get engagementItems() {
        return this.pEngagementItems;
    }

    generateEngagement(_: any) {
        return UserService.getEngagementScores;
    }

    get topics() {
        return this.pTopics;
    }

    generateCompetencies() {
        return UserService.userCompetencies;
    }

    nextPage(pagination: { size: number, page: number }) {
        this.page = pagination.page;
        this.currentPageSize = pagination.size;
    }

    @Watch("page")
    updatePage(_newPage: number, _oldPage: number) {
        this.updateAuthoredQuestions();
    }

    @Watch("currentPageSize")
    updatePageSize(_newSize: number, _oldSize: number) {
        this.updateAuthoredQuestions();
    }

    updateAuthoredQuestions() {
        UserService.getAuthoredQuestions(this.currentUserID, this.currentPageSize, this.page)
            .then(x => this.updateQuestions(x));
    }
            
    @Watch("sortDesc")
    updateSortDesc(_new: Boolean, _old: Boolean) {
        this.resortUsers();
    }

    @Watch("sortOrder")
    updateSortOrder(_new: string, _old: string) {
        this.resortUsers();
    }

    resortUsers() {
        if (this.sortOrder == "Student Number") {
            this.pUsers.sort((a, b) =>
                a.user.userID.localeCompare(b.user.userID));
        } else if (this.sortOrder == "First Name") {
            this.pUsers.sort((a, b) =>
                b.user.name.split(/\s(.+)/)[0]
                    .localeCompare(a.user.name.split(/\s(.+)/)[0]));
        } else {
            this.pUsers.sort((a, b) =>
                b.user.name.split(/\s(.+)/)[1]
                    .localeCompare(a.user.name.split(/\s(.+)/)[1]));
        }
        if (this.sortDesc == false) {
            this.pUsers.reverse();
        }
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/AdminProfiles.vue